import { render, staticRenderFns } from "./AdminTruckBookings.vue?vue&type=template&id=b3a627d6&scoped=true&"
import script from "./AdminTruckBookings.vue?vue&type=script&lang=js&"
export * from "./AdminTruckBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a627d6",
  null
  
)

export default component.exports